/* eslint-disable max-len */
import { Typography } from '@material-ui/core';
import React from 'react';

function OvoLogo({
  className,
  srDescription = 'The OVO Energy logo'
}: {
  className?: string;
  srDescription?: string;
}) {
  return (
    <>
      <Typography
        id="logo_description"
        component="div"
        className="MuiTypography-srOnly"
      >
        {srDescription}
      </Typography>
      <svg
        viewBox="0 0 10 10"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        data-testid="ovoSvgLogo"
        aria-describedby="logo_description"
      >
        <path d="M1.57197 2.95572C2.10276 2.95572 2.58456 3.11414 2.97245 3.40179L2.83362 3.02242H4.34434L4.87514 4.86506L4.98538 5.27778C4.98538 5.27778 5.04662 5.05683 5.10787 4.86506L5.63866 3.02242H7.14938L6.99423 3.40179C7.36579 3.11414 7.86391 2.95572 8.39471 2.95572C8.47229 2.95572 8.54986 2.95572 8.61111 2.9724L7.83125 0L0 2.14696L0.31031 3.32258C0.653285 3.08496 1.09017 2.95572 1.57197 2.95572Z" />
        <path d="M8.47228 4.16669C8.03967 4.16669 7.77783 4.55469 7.77783 5.00884C7.77783 5.49826 8.06624 5.83335 8.47228 5.83335C8.87832 5.83335 9.16672 5.49826 9.16672 5.00884C9.16672 4.9427 9.15154 4.87656 9.15154 4.80602L9.12118 4.68697C9.0339 4.40037 8.80242 4.16669 8.47228 4.16669Z" />
        <path d="M2.22238 5.0085C2.22238 4.55454 1.96054 4.16669 1.52794 4.16669C1.09534 4.16669 0.833496 4.55454 0.833496 5.0085C0.833496 5.49773 1.1219 5.83269 1.52794 5.83269C1.93398 5.85032 2.22238 5.51536 2.22238 5.0085Z" />
        <path d="M8.47225 7.00869C7.38156 7.00869 6.46244 6.3701 6.29088 5.27777L5.66996 6.94147H4.44039L3.81947 5.29037C3.6479 6.3617 2.72879 7.00449 1.6381 7.00449C1.56048 7.00449 1.46653 7.00449 1.38892 6.98769L2.16914 9.99999L10 7.83634L9.68957 6.68519C9.34235 6.91206 8.92159 7.00869 8.47225 7.00869Z" />
      </svg>
    </>
  );
}

export default OvoLogo;
